// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".j-image.clickable {\n  cursor: pointer;\n}\n.j-image.gray {\n  filter: contrast(0.5);\n}", "",{"version":3,"sources":["webpack://./src/components/UI/JImage.scss"],"names":[],"mappings":"AACC;EACC,eAAA;AAAF;AAGC;EACC,qBAAA;AADF","sourcesContent":[".j-image {\n\t&.clickable {\n\t\tcursor: pointer;\n\t}\n\t\n\t&.gray {\n\t\tfilter: contrast(0.5);\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
